import gql from 'graphql-tag';

export const OptimizedFavouriteButtonQuery = gql`
	query OptimizedFavouriteButtonQuery($contentId: ID!) {
		singleContent(id: $contentId) {
			id
			type
			metadata {
				currentuser {
					favourited {
						isFavourite
					}
				}
			}
		}
		contentOperations: singleContent(id: $contentId) {
			id
			operations {
				operation
				targetType
			}
		}
	}
`;
